"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_bootstrap_1 = require("react-bootstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var timesync_1 = require("~contexts/timesync");
var auth_1 = require("~contexts/auth");
function NavbarLink(_a) {
    var children = _a.children, to = _a.to, setCollapsed = _a.setCollapsed, props = __rest(_a, ["children", "to", "setCollapsed"]);
    var match = false;
    if (to != null) {
        try {
            var resolved = (0, react_router_dom_1.useResolvedPath)(to);
            match = ((0, react_router_dom_1.useLocation)().pathname + '/').startsWith(resolved.pathname + '/');
            if (match) {
                if (props['className'] != null) {
                    props['className'] += ' active';
                }
                else {
                    props['className'] = 'active';
                }
            }
        }
        catch (e) {
        }
    }
    else {
        console.log(props, 'Missing to');
    }
    if (props['data-bs-toggle']) {
        return react_1.default.createElement("a", __assign({ href: to }, props), children);
    }
    return react_1.default.createElement(react_router_dom_1.Link, __assign({ to: to, onClick: function () {
            return typeof setCollapsed === 'function' ? setCollapsed() : null;
        } }, props), children);
}
var MenuTypes = {
    DIVIDER: Symbol('MenuTypes.DIVIDER'),
    HEADER: Symbol('MenuTypes.HEADER'),
    PAGE: Symbol('MenuTypes.PAGE'),
    SUBMENU: Symbol('MenuTypes.SUBMENU'),
};
var camelCase = function (s) { return s
    // @ts-ignore
    .replaceAll('/', '')
    .replace(/[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g, function (m) { return +m === 0 ? '' : m.toUpperCase(); }); };
function MenuItem(_a) {
    var name = _a.name, link = _a.link, badge = _a.badge, alias = _a.alias, type = _a.type, children = _a.children, parent = _a.parent, setCollapsed = _a.setCollapsed;
    if (link != null && !link.startsWith('/')) {
        if (parent != null) {
            link = "".concat(parent.link).concat(parent.link.endsWith('/') ? '' : '/').concat(link);
        }
        else {
            link = "/".concat(link);
        }
    }
    if (alias != null) {
        var aliasResolved = [];
        for (var _i = 0, alias_1 = alias; _i < alias_1.length; _i++) {
            var a = alias_1[_i];
            if (a.startsWith('/')) {
                aliasResolved.push(a);
            }
            else if (parent != null) {
                aliasResolved.push("".concat(parent.link).concat(parent.link.endsWith('/') ? '' : '/').concat(a));
            }
            else {
                aliasResolved.push("/".concat(a));
            }
        }
        alias = aliasResolved;
    }
    if (typeof setCollapsed !== 'function') {
        setCollapsed = function () {
        };
    }
    switch (type) {
        case MenuTypes.PAGE:
            return react_1.default.createElement("li", { className: "nav-item mb-1" },
                react_1.default.createElement(NavbarLink, { className: "nav-link", to: link, setCollapsed: function () { return setCollapsed(); } }, name),
                badge && (react_1.default.createElement(react_bootstrap_1.Badge, { bg: badge.type }, badge.text)));
        case MenuTypes.SUBMENU: {
            var resolved = (0, react_router_dom_1.useResolvedPath)(link);
            var locationPath = (0, react_router_dom_1.useLocation)().pathname;
            var match = (locationPath + '/').startsWith(resolved.pathname + '/');
            if (alias != null) {
                for (var _b = 0, alias_2 = alias; _b < alias_2.length; _b++) {
                    var a = alias_2[_b];
                    var aliasResolved = (0, react_router_dom_1.useResolvedPath)(a);
                    match = match || (locationPath + '/').startsWith(aliasResolved.pathname + '/');
                }
            }
            return react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("li", { className: "nav-item mb-1" },
                    react_1.default.createElement(NavbarLink, { to: link, className: "nav-link dropdown-toggle collapsed", "data-bs-toggle": "collapse", "data-bs-target": "#".concat(camelCase(resolved.pathname), "-collapse"), "aria-expanded": match ? 'true' : 'false' }, name),
                    badge && (react_1.default.createElement(react_bootstrap_1.Badge, { bg: badge.type }, badge.text))),
                react_1.default.createElement("li", { className: "collapse".concat(match ? ' show' : ''), id: "".concat(camelCase(resolved.pathname), "-collapse") },
                    react_1.default.createElement("ul", { className: "btn-toggle-nav list-unstyled fw-normal pb-1" }, children.map(function (child, i) { return react_1.default.createElement(MenuItem, __assign(__assign({ key: i, setCollapsed: function () { return setCollapsed(); } }, child), { parent: {
                            link: link,
                            name: name,
                        } })); }))));
        }
        case MenuTypes.DIVIDER:
            return react_1.default.createElement("li", { className: "border-top my-1" });
        case MenuTypes.HEADER:
            return react_1.default.createElement("h6", { className: "dropdown-header" }, name);
        default:
            return react_1.default.createElement("span", null, "Unknown type");
    }
}
function Sidebar() {
    var user = (0, auth_1.useAuth)();
    var timeSync = (0, timesync_1.useTimeSync)();
    var menu = [
        {
            link: '/commands',
            name: 'Commands',
            type: MenuTypes.PAGE,
        },
        {
            children: [
                {
                    name: 'PSO2 and PSO2:NGS',
                    type: MenuTypes.HEADER,
                },
                {
                    link: 'events',
                    name: 'Events',
                    type: MenuTypes.PAGE,
                    badge: {
                        text: 'Not updated',
                        type: 'warning',
                    },
                },
                {
                    link: 'fashion',
                    name: 'Fashion',
                    type: MenuTypes.PAGE,
                    badge: {
                        text: 'Not updated',
                        type: 'warning',
                    },
                },
                {
                    link: 'schedule',
                    name: 'Schedule',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'uq-predictions',
                    name: 'UQ Predictions',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'serverstatus',
                    name: 'Server Status',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'emotes',
                    name: 'Emotes',
                    type: MenuTypes.PAGE,
                    badge: {
                        text: 'Not updated',
                        type: 'warning',
                    },
                },
                {
                    link: 'voices',
                    name: 'Voices',
                    type: MenuTypes.PAGE,
                    badge: {
                        text: 'Not updated',
                        type: 'warning',
                    },
                },
                { type: MenuTypes.DIVIDER },
                {
                    name: 'PSO2:NGS',
                    type: MenuTypes.HEADER,
                },
                {
                    children: [
                        {
                            link: 'alliance-mag',
                            name: 'Alliance Mag',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'class-levels',
                            name: 'Class Levels',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'enhancement-levels',
                            name: 'Enhancement Levels',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'gp-trees',
                            name: 'GP Trees',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'texts',
                            name: 'Texts found in the game',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'preset-skills',
                            name: 'Preset Skills',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'uq-history',
                            name: 'Urgent Quest History',
                            type: MenuTypes.PAGE,
                        },
                    ],
                    link: 'ngs/resources',
                    name: 'Resources',
                    type: MenuTypes.SUBMENU,
                },
                {
                    children: [
                        {
                            link: 'augment-calculator',
                            name: 'Augment Calculator',
                            type: MenuTypes.PAGE,
                        },
                    ],
                    link: 'ngs/tools',
                    name: 'Tools',
                    type: MenuTypes.SUBMENU,
                },
                {
                    link: 'ngs/scratch-tickets',
                    name: 'Scratch Tickets',
                    type: MenuTypes.PAGE,
                    badge: {
                        text: 'Not updated',
                        type: 'warning',
                    },
                },
                {
                    link: 'ngs/timers',
                    name: 'Timers',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'ngs/time',
                    name: 'World Time',
                    type: MenuTypes.PAGE,
                },
                { type: MenuTypes.DIVIDER },
                {
                    name: 'PSO2',
                    type: MenuTypes.HEADER,
                },
                {
                    children: [
                        {
                            link: 'catalysts',
                            name: 'Catalysts',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'class-levels',
                            name: 'Class Levels',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'divide-quests',
                            name: 'Divide Quests',
                            type: MenuTypes.PAGE,
                        },
                        {
                            link: 'triggers',
                            name: 'Triggers',
                            type: MenuTypes.PAGE,
                        },
                    ],
                    link: 'resources',
                    name: 'Resources',
                    type: MenuTypes.SUBMENU,
                },
                {
                    children: [
                        {
                            link: 'augment-upgrade-calculator',
                            name: 'Augment Upgrade Calculator',
                            type: MenuTypes.PAGE,
                        },
                    ],
                    link: 'tools',
                    name: 'Tools',
                    type: MenuTypes.SUBMENU,
                },
                {
                    link: 'timers',
                    name: 'Timers',
                    type: MenuTypes.PAGE,
                },
            ],
            link: '/pso2/global',
            name: 'PSO2 Global',
            type: MenuTypes.SUBMENU,
        },
        /*
        {
          children: [
            {
              link: 'serverstatus',
              name: 'Server Status',
              type: MenuTypes.PAGE,
              badge: {
                text: 'Not updated',
                type: 'warning',
              },
            },
          ],
          link: '/pso2/jp',
          name: 'PSO2 JP',
          type: MenuTypes.SUBMENU,
        },*/
        {
            children: [
                {
                    link: 'timers',
                    name: 'Timers',
                    type: MenuTypes.PAGE,
                },
            ],
            link: '/genshin',
            name: 'Genshin',
            type: MenuTypes.SUBMENU,
        },
        {
            children: [
                {
                    link: 'events',
                    name: 'Events',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'records-of-eminence',
                    name: 'Records of Eminence',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'storage-slips',
                    name: 'Storage Slips',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'vanabout',
                    name: 'Vana\'bout',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'world-time',
                    name: 'World Time',
                    type: MenuTypes.PAGE,
                },
            ],
            link: '/ffxi',
            name: 'FFXI',
            type: MenuTypes.SUBMENU,
        },
        {
            children: [
                {
                    link: 'serverstatus',
                    name: 'Server Status',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'timers',
                    name: 'Timers',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'time',
                    name: 'World Time and Weather',
                    type: MenuTypes.PAGE,
                },
                { type: MenuTypes.DIVIDER },
                {
                    name: 'Stormblood',
                    type: MenuTypes.HEADER,
                },
                {
                    link: 'eureka',
                    name: 'Eureka NMs',
                    type: MenuTypes.PAGE,
                },
                { type: MenuTypes.DIVIDER },
                {
                    name: 'Endwalker',
                    type: MenuTypes.HEADER,
                },
                {
                    link: 'endwalker/sightseeing-log',
                    name: 'Sightseeing Log',
                    type: MenuTypes.PAGE,
                },
            ],
            link: '/ffxiv',
            name: 'FFXIV',
            type: MenuTypes.SUBMENU,
        },
        {
            children: [
                {
                    link: 'events',
                    name: 'Events',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'gachas',
                    name: 'Gachas',
                    type: MenuTypes.PAGE,
                },
                {
                    link: 'virtual-lives',
                    name: 'Virtual Lives',
                    type: MenuTypes.PAGE,
                },
            ],
            link: '/project-sekai',
            name: 'Project Sekai',
            type: MenuTypes.SUBMENU,
        },
        /*
        {
          children: [
            {
              link: 'clan-battles',
              name: 'Clan Battles',
              type: MenuTypes.PAGE,
            },
            {
              link: 'gachas',
              name: 'Gachas',
              type: MenuTypes.PAGE,
            },
          ],
          link: '/priconne',
          name: 'Priconne',
          type: MenuTypes.SUBMENU,
        },*/
        /*{
          children: [
            {
              link: 'chaos-gates',
              name: 'Chaos Gates',
              type: MenuTypes.PAGE,
            },
            {
              link: 'procyons-compass',
              name: 'Procyon\'s Compass',
              type: MenuTypes.PAGE,
            },
            {
              link: 'timers',
              name: 'Timers',
              type: MenuTypes.PAGE,
            },
          ],
          link: '/lostark',
          name: 'Lost Ark',
          type: MenuTypes.SUBMENU,
        },*/
        {
            link: '/about-us',
            name: 'About us',
            type: MenuTypes.PAGE,
        },
    ];
    if (user === null || user === void 0 ? void 0 : user.is_admin) {
        menu.push({
            children: [
                {
                    link: 'pso2/scratch-ticket',
                    name: 'PSO2 Scratch',
                    type: MenuTypes.PAGE,
                },
            ],
            link: '/admin',
            name: 'Admin',
            type: MenuTypes.SUBMENU,
        });
    }
    var _a = (0, react_1.useState)(0), offset = _a[0], setOffset = _a[1];
    timeSync.on('change', function (offset) { return setOffset(offset); });
    var _b = (0, react_1.useState)(true), collapsed = _b[0], setCollapsed = _b[1];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "d-lg-none container-fluid" },
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { className: "p-0" },
                    react_1.default.createElement("nav", { className: "navbar navbar-dark bg-dark fixed-top px-3" },
                        react_1.default.createElement("button", { className: "btn btn-sm float-end", type: "button", onClick: function () { return setCollapsed(!collapsed); }, "aria-controls": "navbarSupportedContent", "aria-expanded": "false", "aria-label": "Toggle navigation" },
                            react_1.default.createElement("span", { className: "navbar-toggler-icon" })))))),
        react_1.default.createElement("nav", { className: "sidebar d-block d-lg-flex flex-column flex-shrink-0 navbar-dark bg-dark p-3 overflow-auto".concat(collapsed ? ' collapsed' : '') },
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement("a", { className: "navbar-brand", href: "/" }, "NekoBot")),
                react_1.default.createElement(react_bootstrap_1.Col, { className: "d-lg-none" },
                    react_1.default.createElement("button", { className: "navbar-toggler float-end", type: "button", onClick: function () { return setCollapsed(!collapsed); }, "aria-controls": "navbarSupportedContent", "aria-expanded": "false", "aria-label": "Toggle navigation" },
                        react_1.default.createElement("span", { className: "navbar-toggler-icon" })))),
            react_1.default.createElement("ul", { className: "navbar-nav d-flex flex-column flex-shrink-0 mb-auto" }, menu.map(function (menuItem, i) { return react_1.default.createElement(MenuItem, __assign({ key: i, setCollapsed: function () { return setCollapsed(true); } }, menuItem)); })),
            react_1.default.createElement("div", { className: "d-none" },
                react_1.default.createElement("div", { className: "mb-1" },
                    react_1.default.createElement("a", { href: "https://stickywaifu.com", target: "_blank", rel: "noreferrer" },
                        react_1.default.createElement(react_bootstrap_1.Image, { src: "/images/stickywaifu.png", alt: "Sticky Waifu", fluid: true, rounded: true })))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "btn-group w-100 mb-1", role: "group", "aria-label": "Twitter links" },
                    react_1.default.createElement("button", { type: "button", className: "btn pt-0 pb-0 col-3", style: { backgroundColor: '#1DA1F2', width: 45 } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_brands_svg_icons_1.faTwitter })),
                    react_1.default.createElement("a", { href: "https://twitter.com/NekoBotIO", target: "_blank", rel: "noreferrer", className: "btn btn-secondary col-9" }, "@NekoBotIO"))),
            react_1.default.createElement("div", { className: "btn-group w-100", role: "group", "aria-label": "Discord links" },
                react_1.default.createElement("button", { type: "button", className: "btn pt-0 pb-0 col-3", style: { backgroundColor: '#5865F2', width: 45 } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_brands_svg_icons_1.faDiscord })),
                react_1.default.createElement("a", { href: "https://discord.com/oauth2/authorize?client_id=750023099386429571&scope=bot&permissions=2147483648", target: "_blank", rel: "noreferrer", className: "btn btn-secondary col-9" }, "Invite me")),
            react_1.default.createElement("span", { className: "navbar-text" },
                "Time offset: ",
                (offset / 1e3).toFixed(3),
                "s"),
            user ? react_1.default.createElement("ul", { className: "navbar-nav" },
                react_1.default.createElement("li", { className: "nav-item dropdown" },
                    react_1.default.createElement("a", { className: "nav-link dropdown-toggle", href: "#", id: "navbarDropdownMenuLink", role: "button", "data-bs-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" }, user.name),
                    react_1.default.createElement("div", { className: "dropdown-menu dropdown-menu-right", "aria-labelledby": "navbarDropdownMenuLink" },
                        react_1.default.createElement("a", { className: "dropdown-item", href: "/auth/logout" }, "Logout")))) : react_1.default.createElement("ul", { className: "navbar-nav d-none" },
                react_1.default.createElement("li", { className: "nav-item mb-1" },
                    react_1.default.createElement("a", { className: "nav-link", href: "/auth/discord" }, "Login with Discord")))));
}
exports.Sidebar = Sidebar;
